import { render, staticRenderFns } from "./AIPlugins.vue?vue&type=template&id=125cfee4&scoped=true"
import script from "./AIPlugins.vue?vue&type=script&lang=js"
export * from "./AIPlugins.vue?vue&type=script&lang=js"
import style0 from "./AIPlugins.vue?vue&type=style&index=0&id=125cfee4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125cfee4",
  null
  
)

export default component.exports